import React, { useState } from "react";
import { PostStepProps } from "../Detail";
import { Button, Col, Divider, Form, Input, Modal, Row, Spin, Typography, message } from "antd";
import { useHistory } from "react-router-dom";
import DetailItem from "../../../../components/DetailItem";
import ListComment from "./ListComment";
import { PlusOutlined } from "@ant-design/icons";
import { generateFormRules } from "../../../../helpers/formRules";
import { getErrorMessage } from "../../../../helpers/errorHandler";
import useAuth from "../../../../hooks/useAuth";
import { getMainEmailAddress } from "../../../../helpers/profile";
import { httpRequest } from "../../../../helpers/api";
import { ArticleCommentProperties } from "../../../../types/blog.type";

interface FormValues {
	comment: string;
}
const DetailDescriptionPost: React.FC<PostStepProps> = ({ articleId, post, setIsFetch }) => {
	const history = useHistory();
	const [showModalAddComment, setShowModalAddComment] = useState(false);
	const [type, setType] = useState<"comment" | "reply">("comment");
	const [tempComment, setTempComment] = useState<ArticleCommentProperties>();

	const [form] = Form.useForm();
	const [isActionLoading, setIsActionLoading] = useState(false);
	const { user } = useAuth();

	const doSubmit = async (values: FormValues) => {
		setIsActionLoading(true);

		try {
			if (type === "comment") {
				const dto = {
					articleId: post?.articleId,
					email: getMainEmailAddress(user?.profile!),
					comment: values?.comment,
					name: user.nickName,
				};

				await httpRequest.post("/article-comments", dto);
			} else {
				const dto = {
					commentId: tempComment?.commentId,
					comment: values?.comment,
					name: user.nickName,
					email: getMainEmailAddress(user?.profile!),
				};

				await httpRequest.post("/article-reply-comments", dto);
			}

			setIsFetch?.(true);
			reset();
		} catch (error) {
			message.error(getErrorMessage(error));
		}
		setIsActionLoading(false);
	};

	const reset = () => {
		setShowModalAddComment(false);
		form.resetFields();
		setType("comment");
		setTempComment(undefined);
	};

	return (
		<>
			<Row gutter={[24, 0]}>
				<Col span={24}>
					<DetailItem
						label="Description"
						value={post?.body}
						renderValue={(value) => (
							<div
								className="blog-desc-container"
								dangerouslySetInnerHTML={{ __html: value as string }}
							/>
						)}
					/>
				</Col>
				{/* <Divider />
				<Col span={24}>
					<Row
						justify="space-between"
						style={{
							marginBottom: 16,
						}}
					>
						<Typography.Title
							style={{
								marginTop: 0,
							}}
							level={4}
						>
							{post?.comments.length} Comments
						</Typography.Title>
						<Button
							type="primary"
							icon={<PlusOutlined />}
							onClick={() => {
								setShowModalAddComment(true);
							}}
						>
							Add Comment
						</Button>
					</Row>

					<ListComment
						onReplyClick={(comment) => {
							setType("reply");
							setShowModalAddComment(true);
							setTempComment(comment);
						}}
						comments={post?.comments ?? []}
						setIsFetch={setIsFetch}
					/>
				</Col> */}
			</Row>
			<Row gutter={[24, 0]}>
				<Col
					span={24}
					style={{ height: 20 }}
				></Col>

				<Col span={12}>
					<Button
						onClick={() => history.replace("/blog-posts/" + articleId + "/detail-post")}
						className="btn-fixed-lg"
					>
						Previous
					</Button>
				</Col>
				<Col
					span={12}
					style={{ textAlign: "right" }}
				>
					<Button
						type="primary"
						className="btn-fixed-lg"
						disabled
					>
						Next
					</Button>
				</Col>
			</Row>

			<Modal
				destroyOnClose={true}
				title={`Add ${type === "reply" ? "Reply" : "Comment"}`}
				open={showModalAddComment}
				onCancel={() => {
					reset();
				}}
				onOk={form.submit}
				okText={"Add"}
				okButtonProps={{
					loading: isActionLoading,
				}}
				width={520}
			>
				<Spin spinning={isActionLoading}>
					<Form
						form={form}
						preserve={false}
						layout="vertical"
						name="basic"
						autoComplete="off"
						onFinish={doSubmit}
					>
						<Form.Item
							name="comment"
							label={type === "comment" ? "Comment" : "Reply"}
							rules={generateFormRules(type === "comment" ? "Comment" : "Reply", ["required"])}
						>
							<Input.TextArea
								rows={3}
								placeholder={`Enter a ${type === "comment" ? "comment" : "reply"}`}
							/>
						</Form.Item>
					</Form>
				</Spin>
			</Modal>
		</>
	);
};

export default DetailDescriptionPost;
